import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  ssoConfig: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/login/vuex/index.js